<template>
    <div class="private-list init">
        <div class="cps-page-top">
            <div class="jc-page-header">
                <el-page-header :title="$t('privateNetwork.privateNetwork')" />
                <div class="jc-box-action">
                    <a target="_blank" :href="Config.VPC_URL">
                        {{ $t('privateNetwork.privateHelpDoc') }}
                    </a>
                </div>
            </div>
            <div class="jc-page-content">
                <div class="jc-container-table">
                    <div class="jc-container-table-actionBar flex-display">
                        <el-form class="jc-table-actionBar-item" :inline="true">
                            <el-form-item>
                                <el-button icon="jc-icon-refresh-line" class="jc-button-icon" @click="iconRefresh">
                                </el-button>
                            </el-form-item>
                            <el-form-item>
                                <el-radio-group v-model="area" @change="regionChange">
                                    <el-radio-button v-for="region in regions" :label="region.region" :key="region.region">
                                        {{ region.regionName }}
                                    </el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item>
                                <el-button @click="changeVisibile" type="primary">
                                    {{ $t('privateNetwork.create') }}
                                </el-button>
                            </el-form-item>
                        </el-form>
                        <el-form class="jc-box-table-search" :inline="true" @submit.native.prevent>
                            <el-form-item>
                                <el-input v-model.trim="vpcName" :placeholder="$t('eip.placeholder.search.name')"
                                    :maxlength="32" @keyup.enter.native="handleIconClick" v-entire-placeholder
                                    class="search-input">
                                    <el-button slot="append" icon="jc-icon-search" @click="handleIconClick">
                                    </el-button>
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button class="jc-button-icon operate-icon" icon="el-icon-setting"
                                    @click="customVisible = true" :title="$t('listPage.text.customList')">
                                </el-button>
                            </el-form-item>
                            <el-form-item>
                                <el-button class="jc-button-icon operate-icon" icon="jc-icon-download" @click="downloadList"
                                    :title="$t('listPage.text.exportList')">
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <el-table :data="tableList" :empty-text="$t('speechCraft.listEmptyText')" style="width: 100%"
                        v-loading="loading">
                        <el-table-column prop="name" :label="$t('privateNetwork.tableTitle.name')"
                            v-if="customInfo !== null && customInfo['id'].selected">
                            <template slot-scope="scope">
                                <a href="javascript:void(0)"
                                    @click="jumpToDetail('source', scope.row.name, scope.row.vpcId, scope.row.peeringCount, scope.row.lbCount)">
                                    {{ scope.row.name }}
                                </a>
                            </template>
                        </el-table-column>
                        <el-table-column prop="cidr" :label="$t('privateNetwork.tableTitle.cidr')"
                            v-if="customInfo !== null && customInfo['cidr'].selected">
                            <template slot-scope="scope">
                                <span>{{ scope.row.cidr | maybeEmpty }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="ipv6Cidr" :label="$t('privateNetwork.tableTitle.ipv6Cidr')"
                            v-if="customInfo !== null && customInfo['ipv6Cidr'].selected">
                            <template slot-scope="scope">
                                <span>{{ scope.row.ipv6Cidr | maybeEmpty }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="subnetCount" :label="$t('privateNetwork.tableTitle.subNet')"
                            v-if="customInfo !== null && customInfo['subnet'].selected">
                            <template slot-scope="scope">
                                <a href="javascript:void(0)"
                                    @click="jumpToDetail('subnet', scope.row.name, scope.row.vpcId, scope.row.peeringCount, scope.row.lbCount)">
                                    {{ scope.row.subnetCount }}
                                </a>
                            </template>
                        </el-table-column>
                        <el-table-column prop="createTime" :label="$t('privateNetwork.tableTitle.createTime')"
                            v-if="customInfo !== null && customInfo['datetime'].selected">
                            <template slot-scope="scope">
                                <span>{{ transformTime(scope.row.createTime) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="operate" :label="$t('privateNetwork.tableTitle.operate')" key="operation"
                            v-if="customInfo !== null && customInfo['operation'].selected">
                            <template slot-scope="scope">
                                <el-tooltip v-if="scope.row.name.indexOf('Default-Game') === -1" placement="bottom"
                                    :content="$t('privateNetwork.deleteTip')" :visible-arrow="false"
                                    :disabled="scope.row.subnetCount === 0 && scope.row.lbCount === 0 && scope.row.peeringCount === 0">
                                    <div slot="content">{{ scope.row.subnetCount !== 0 ? $t('privateNetwork.deleteTip') :
                                        $t('privateNetwork.deleteForPeering') }}</div>
                                    <label>
                                        <el-button type="text" @click="openDel(scope.row)"
                                            :disabled="scope.row.subnetCount !== 0 || scope.row.peeringCount !== 0 || scope.row.lbCount !== 0">
                                            {{ $t('privateNetwork.delete') }}
                                        </el-button>
                                    </label>
                                </el-tooltip>
                                <el-tooltip v-else placement="bottom" :visible-arrow="false">
                                    <div slot="content">如需删除请<a :href="Config.WORK_ORDER_URL" target="_blank"
                                            style="color:#2C68FF">{{
                                                $t('privateNetInstance.submit') }}</a>
                                    </div>
                                    <label>
                                        <el-button type="text" :disabled="true">
                                            {{ $t('privateNetwork.delete') }}
                                        </el-button>
                                    </label>
                                </el-tooltip>
                                <el-button type="text" v-if="!scope.row.ipv6Cidr" @click="openIpv6(scope.row)">
                                    {{ $t('privateNetwork.openIpv6') }}
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <custom :visible.sync="customVisible" v-if="customVisible" :optionArr="optionArr" :type="type">
                </custom>
            </div>
        </div>
        <div class="cps-page-footer block jc-container-table-actionBar" v-if="listTotal > 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="listTotal">
            </el-pagination>
        </div>
        <create-private-sub :visible.sync="createShow" v-if="createShow" :regions="regions" :initRegion="area"
            @refresh="refreshList({})">
        </create-private-sub>
        <del-private-sub :visible.sync="delShow" :vpcName="currentRow.name" :vpcId="currentRow.vpcId"
            :ipv6Cidr="currentRow.ipv6Cidr" :region="area" @refresh="refreshList({})">
        </del-private-sub>
        <ipv6-private :visible.sync="ipv6PrivateShow" :vpcName="currentRow.name" :vpcId="currentRow.vpcId" :region="area"
            @refresh="refreshList({})">
        </ipv6-private>
    </div>
</template>

<script>
import {
    NetworkTypeConstant
} from '@/common/Constants';
import createPrivateSub from '@/components/privateNetwork/createPrivateSub/CreatePrivateSub';
import delPrivateSub from '@/components/privateNetwork/delPrivateSub/DelPrivateSub';
import ipv6Private from '@/components/privateNetwork/ipv6Private/ipv6Private';
import { getYMD } from '@/common/dataHelper';
import custom from '@/components/common/custom/Custom';

export default {
    name: 'PrivateNetworkList',
    components: {
        createPrivateSub,
        delPrivateSub,
        ipv6Private,
        custom
    },
    data() {
        return {
            loading: false,
            link: '',
            createShow: false,
            delShow: false,
            ipv6PrivateShow: false,
            regions: [],
            area: '',
            currentPage: 1,
            pageSizes: [20, 50, 100],
            pageSize: 20,
            vpcName: '',
            tableList: [],
            type: 'vpcList',
            optionArr: [
                {
                    // ID/名称
                    label: this.$t('privateNetInstance.listTitle.onlyName'),
                    value: 'id'
                },
                {
                    // cidr
                    label: this.$t('privateNetInstance.listTitle.cidr'),
                    value: 'cidr'
                },
                {
                    // ipv6Cidr
                    label: this.$t('privateNetwork.tableTitle.ipv6Cidr'),
                    value: 'ipv6Cidr'
                },
                {
                    // 子网
                    label: this.$t('privateNetInstance.listTitle.subnet'),
                    value: 'subnet'
                },
                {
                    // 创建时间
                    label: this.$t('privateNetInstance.listTitle.createTime'),
                    value: 'datetime'
                },
                {
                    // 操作
                    label: this.$t('privateNetInstance.listTitle.operate'),
                    value: 'operation'
                }
            ],
            customVisible: false,
            currentRow: {}, // 当前操作行
            listTotal: 0
        };
    },
    computed: {
        customInfo() {
            return this.$store.state.customInfo[this.type];
        }
    },
    created() {
        if (this.$store.state.customInfo[this.type] === null) {
            this.getCustomInfo();
        }
        this.getRegions();
    },
    methods: {
        openDel(row) {
            //Pop.del_private_net(this, row, 'list');
            this.currentRow = row;
            this.delShow = true;
        },
        openIpv6(row) {
            this.currentRow = row;
            this.ipv6PrivateShow = true;
        },
        // 根据区域名称获得区域
        getRegionByName(name) {
            let tempRegion;
            this.regions.forEach((region) => {
                if (region.regionName === name) {
                    tempRegion = region.region;
                }
            });
            return tempRegion;
        },
        // 获取私有网络列表
        getPrivateNetList(params) {
            this.loading = true;
            Ajax.get('/api/cps/listVpcs', params).then((res) => {
                if (res.errno === 10000 && res.data) {
                    this.tableList = res.data.vpcs;
                    this.listTotal = res.data.totalCount;
                }
            }).catch(async (err) => {
                const { response } = err.data;
                try {
                    const json = await response.json();
                    // this.$message.error(json.errmsg);
                    this.tableList = [];
                    this.listTotal = 0;
                } catch (ex) {
                    console.log(ex);
                }
            })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 切换可用区
        regionChange(region) {
            this.vpcName = '';
            this.pageSize = 20;
            this.currentPage = 1;
            const params = {
                region
            };
            this.getPrivateNetList(params);
        },
        // 初始化创建弹窗
        changeVisibile() {
            this.createShow = true;
        },
        // 获得可用区
        getRegions() {
            const params = {
                networkType: NetworkTypeConstant.VPC
            };
            Ajax.get('api/cps/getRegions', params).then((res) => {
                const target = this;
                if (res.errno === 10000 && res.data) {
                    res.data.regions.forEach((region, index) => {
                        if (index === 0) {
                            if (target.$route.query && target.$route.query.region) {
                                target.area = target.$route.query.region;
                            } else {
                                target.area = region.region;
                            }
                        }
                        const tempFormat = {};
                        tempFormat.region = region.region;
                        tempFormat.regionName = region.regionName;
                        target.regions.push(tempFormat);
                    });
                }
            }).catch()
                .finally(() => {
                    this.iconRefresh()
                });
        },
        iconRefresh() {
            const params = {};
            this.refreshList(params);
        },
        // 刷新列表
        refreshList(refreshParams) {
            const defaultParams = {
                region: this.area,
                pageSize: this.pageSize,
                pageNumber: this.currentPage,
            };
            if (this.vpcName !== '') {
                defaultParams.name = this.vpcName;
            }
            const realParams = Object.assign({}, defaultParams, refreshParams);
            this.getPrivateNetList(realParams);
        },
        // 分页条数变化
        handleSizeChange(size) {
            this.pageSize = size;
            const params = {
                pageSize: size,
            };
            this.refreshList(params);
        },
        // 分页页数变化
        handleCurrentChange(page) {
            this.currentPage = page;
            this.refreshList({});
        },
        // 点击搜索进行搜索
        handleIconClick() {
            const region = this.area;
            const params = {
                region,
            };
            if (this.vpcName) {
                params.name = this.vpcName;
            }
            this.refreshList(params);
        },
        // 转换时间格式
        transformTime(time) {
            return (getYMD(new Date(time)));
        },
        // 点击跳转到详情页
        jumpToDetail(tabName, vpcName, vpcId, peeringCount, lbCount) {
            this.$router.push({
                path: '/vpc/detail',
                query: {
                    region: this.area,
                    vpcName,
                    tabName,
                    id: vpcId,
                    peeringCount,
                    lbCount
                }
            });
        },
        // 下载列表
        downloadList() {
            const params = {
                region: this.area,
                pageNumber: this.currentPage,
                pageSize: this.pageSize,
            };
            Ajax.download('GET', '/api/export/listVpcs', params, { baseURL: '/cps_api' })
                .then((res) => {
                    console.log(res, 'down--res');
                });
        },
        getCustomInfo() {
            const params = {
                pageKey: this.type
            };
            Ajax.get('/api/usercenter/getCustomInfo', params)
                .then((res) => {
                    if (res.data.customInfo) {
                        this.$store.commit('GET_CUSTOMINFO', { value: res.data.customInfo, type: this.type });
                    }
                })
                .catch()
                .finally();
        }
    }
};
</script>

<style lang="scss">
@import "PrivateNetworkList";
@import '../../../assets/scss/listComon';
@import "../../../assets/scss/paginationCommon";
</style>



// WEBPACK FOOTER //
// src/views/privateNetwork/list/PrivateNetworkList.vue